import React, { PureComponent } from 'react'
import { ImageFrame } from '../Frame/ImageFrame'
import btn from '../../assets/img/tutorial-banner-btn.png'
import { postMessage } from '../../utils'

const TITLE = '新手必看'
let imgUrl = ''
switch (process.env['REACT_APP_CHANNEL']) {
  case 'xiniu':
  case 'trading':
  case 'tradeasy':
    imgUrl = 'http://cdn.dev.hnqcwlkj.com/1733729601296.jpeg'
    break
  case 'qxyg':
    imgUrl = 'https://cdn.qxtj.hnjcwlkj.cn/1734932636662.jpeg'
    break
  case 'qxtj':
    imgUrl = 'https://cdn.qxtj.hnjcwlkj.cn/1734932659968.jpeg'
    break
  case 'qxdg':
    imgUrl = 'https://cdn.qxtj.hnjcwlkj.cn/1744006599539.png'
    break
  case 'tjyg':
    imgUrl = 'http://cdn.dev.qxtj.hnjcwlkj.cn/1742957070422.jpeg'
    break
  case 'xbyg':
    imgUrl = 'https://cdn.hnqcwlkj.com/1764663832140.jpeg'
    break
  case 'xibei':
    if(process.env['REACT_APP_BUILD_ENV'] === 'development') {
      imgUrl = 'http://cdn.dev.hnqcwlkj.com/1705557264624.jpeg'
    } else {
      imgUrl = 'https://cdn.hnqcwlkj.com/1705483787089.jpeg'
    }
    break
  case 'wanshun':
    if(process.env['REACT_APP_BUILD_ENV'] === 'development') {
      imgUrl = 'http://cdn.dev.hnqcwlkj.com/1705557264624.jpeg'
    } else {
      imgUrl = 'https://cdn.hnqcwlkj.com/1705483787089.jpeg'
    }
    break
  case 'youpin':
    if(process.env['REACT_APP_BUILD_ENV'] === 'development') {
      // http://api.dev.hnqcwlkj.com/html/v1/article/html/b1972069-bac8-4a20-8536-e83572743dfe
      imgUrl = 'http://cdn.dev.hnqcwlkj.com/1757568036811.jpeg'
    } else {
      // https://api.hnqcwlkj.com/html/v1/article/html/42b90bf4-28de-42be-b0f0-812f8175f7a3
      imgUrl = 'https://cdn.hnqcwlkj.com/1757564592787.jpeg'
    }
    break
  case 'haiou':
    if(process.env['REACT_APP_BUILD_ENV'] === 'development') {
      // 20231123 没找到测试的
      imgUrl = 'https://cdn.wsgold.com.cn/1684766965897.jpeg'
    } else {
      imgUrl = 'https://cdn.wsgold.com.cn/1684766965897.jpeg'
    }
    break
  default:
}

export class BannerDetails extends PureComponent {
  constructor (props) {
    super(props)
    document.title = TITLE
    const { search: SearchParams } = props.location
    const urlParams = new URLSearchParams(SearchParams)
    this.withHeader = urlParams.get('withHeader')
  }

  render () {
    return <ImageFrame
      // imgSrc={process.env['REACT_APP_BUILD_ENV'] === 'development' ? 'http://cdn.bl.dev.seedtecgz.com/1698139642894.jpeg' : 'https://cdn.wsgold.com.cn/1684766965897.jpeg'}
      // imgSrc={process.env['REACT_APP_CHANNEL'] === '' ? 'http://cdn.bl.dev.seedtecgz.com/1698139642894.jpeg' : 'https://cdn.wsgold.com.cn/1684766965897.jpeg'}
      imgSrc={imgUrl}
      title={TITLE}
      withHeader={this.withHeader}
      btnRender={() => <div style={{ position: 'absolute', bottom: 48, left: 0, right: 0, textAlign: 'center' }}>
        <img onClick={this.onBtnClick} style={{ width: '54%', margin: 'auto' }} src={btn} alt=""/>
      </div>}
    />
  }

  onBtnClick = () => {
    postMessage({ type: window.POST_TYPE.RECHARGE })
  }
}
